import * as React from 'react';
import getCalendarIconTransformSvg from '../utils/getCalendarIconTransformSvg';
import { getDate, today } from 'owa-datetime';

const styles = require('./CalendarIcon.scss');

/**
 * Returns the calendar svg when the calendar module is not selected
 */
export const CalendarIconDefault = React.forwardRef(
    (props: any, ref: React.RefObject<any>): JSX.Element => {
        const todayDate = getDate(today());
        const calendarIcon = (
            <svg ref={ref} className={styles.calendarModuleSVG} viewBox="0 0 24 21.76">
                <g id="Todays-date">
                    <text
                        id="todayDate"
                        className={styles.svgText}
                        transform={getCalendarIconTransformSvg(todayDate)}>
                        {todayDate}
                    </text>
                    <path
                        className={styles.svgIcon}
                        d="M19.5,2.07H24V20.74H0V2.07H4.5V0H6V2.07H18V0h1.5ZM4.5,3.41h-3v16h21v-16H4.5Z"
                        transform="translate(0 0)"
                    />
                </g>
            </svg>
        );

        return calendarIcon;
    }
);
